import { render, staticRenderFns } from "./PaymentAdjustment.vue?vue&type=template&id=4f121338&"
import script from "./PaymentAdjustment.vue?vue&type=script&lang=js&"
export * from "./PaymentAdjustment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f121338')) {
      api.createRecord('4f121338', component.options)
    } else {
      api.reload('4f121338', component.options)
    }
    module.hot.accept("./PaymentAdjustment.vue?vue&type=template&id=4f121338&", function () {
      api.rerender('4f121338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/PaymentAdjustment.vue"
export default component.exports